import React from "react"
import { MODAL_FORM_CLOSE_SPRINT_MODE } from "../../../../consts/modules/clientReport.consts"
import ClientChip from "../../../../components/molecules/ClientChip.molecule"

const ModalFinishClientSprintHeaderTemplate = ({
  mode,
  sprintNumber,
  clientCode = "",
  clientName = "",
}) => {
  if (!clientCode) {
    return null
  }
  let title = `Cerrar sprint ${sprintNumber}`
  if (mode === MODAL_FORM_CLOSE_SPRINT_MODE.APPROVE) {
    title = `Aprobar sprint ${sprintNumber}`
  }
  if (mode === MODAL_FORM_CLOSE_SPRINT_MODE.FINISHED_EDIT) {
    title = `Editar puntos del sprint ${sprintNumber}`
  }
  let iconClassName = "pi pi-flag"
  if (mode === MODAL_FORM_CLOSE_SPRINT_MODE.APPROVE) {
    iconClassName = "pi pi-check"
  } else if (mode === MODAL_FORM_CLOSE_SPRINT_MODE.FINISHED_EDIT) {
    iconClassName = "pi pi-pencil"
  }
  return (
    <div className="flex gap-3 align-items-center">
      <i
        className={`${iconClassName} text-3xl`}
        style={{ color: "var(--clr-info__dark)" }}
      />
      <div className="flex flex-column gap-2">
        <span className="text-3xl font-semibold font-cairo line-height-1">
          {title}
        </span>
        <div className="flex gap-2 align-items-center">
          <ClientChip clientCode={clientCode} />
          <span className="font-semibold font-cairo line-height-1">
            {clientName}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ModalFinishClientSprintHeaderTemplate
